import axios from "axios";
import app from "firebase/compat/app";

const instance = axios.create({
	baseURL: "https://sushizoom-api.ithinkers.fun/api",
	// baseURL: "http://localhost:7777/api",
});

const getWriteHeaders = () => {
	const firebaseUid = app.auth()?.currentUser?.uid;
	const token = firebaseUid;

	if (!token) return {};

	return { Authorization: `Bearer ${token}` };
};

export const sushizoomAPI = {
	getCities() {
		return instance
			.get(`/cities`)
			.then((response) => {
				const data = response.data;
				console.log("data **** ", data);
				return data;
			})
			.catch((err) => console.log("err", err));
	},
	getBanners() {
		return instance
			.get("/banners")
			.then((response) => response.data)
			.catch((err) => {
				console.log("get banners error", err);
				return [];
			});
	},
	saveBanners(banners) {
		return instance
			.post("/banners", banners, { headers: getWriteHeaders() })
			.then((response) => response.data)
			.catch((err) => {
				const errorMessage =
					(err &&
						err.response &&
						err.response.data &&
						err.response.data.error) ||
					(err && err.message) ||
					"Unknown error";

				return { ok: false, error: errorMessage };
			});
	},
};
